import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useLayoutEffect, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types'; // import _ from 'lodash'

import Hls from 'hls.js';
import moment from 'moment';
var initialState = JSON.parse(document.getElementById('initial-state').innerHTML || '{}');
var cfg = initialState.envCfg;
var TIMER_INTERVAL = (cfg === null || cfg === void 0 ? void 0 : cfg.hlsPlaybackseconds) > 0 ? (cfg === null || cfg === void 0 ? void 0 : cfg.hlsPlaybackseconds) * 1000 : null;
var ITSVideoPlayer = /*#__PURE__*/React.memo(function (props) {
  var id = props.id,
      videoData = props.videoData,
      index = props.index;

  var renderVideoplayer = function renderVideoplayer() {
    switch (videoData.dataSource.toUpperCase()) {
      case 'EVMS':
        return /*#__PURE__*/React.createElement(EVMSVideoPlayer, {
          streamUrlType: videoData.streamUrlType,
          streamUrl: videoData.streamUrl,
          index: index,
          height: 310
        });

      case 'FREEWAY':
        return /*#__PURE__*/React.createElement(FreewayVideoPlayer, {
          streamUrl: videoData.streamUrl,
          height: 310
        });

      case 'TBKC':
        return /*#__PURE__*/React.createElement(TBKCVideoPlayer, {
          streamUrl: videoData.streamUrl,
          height: 310
        });

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: 'its-videoPlayer'
  }, renderVideoplayer());
});
ITSVideoPlayer.defaultProps = {
  id: 'g-its-videoPlayer'
};
ITSVideoPlayer.propTypes = {
  id: PropTypes.string,
  streamUrl: PropTypes.string
};
export default ITSVideoPlayer;

var HlsVideoPlayer = function HlsVideoPlayer(props) {
  var streamUrl = props.streamUrl,
      videoStatus = props.videoStatus,
      index = props.index,
      handleVideoStatus = props.handleVideoStatus,
      triggerReload = props.triggerReload,
      setTriggerReload = props.setTriggerReload;

  var _hls = useRef();

  var _timer = useRef();

  var videoRef = useRef();

  var _useState = useState('loading'),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      pageResume = _useState4[0],
      setPageResume = _useState4[1];

  var createVideoTimer = function createVideoTimer() {
    if (!_timer.current && TIMER_INTERVAL && TIMER_INTERVAL > 0) {
      _timer.current = setTimeout(function () {
        if (videoRef.current) {
          videoRef.current.pause();
        }

        if (_hls.current) {
          _hls.current.stopLoad();
        }

        setTriggerReload(false);
        handleVideoStatus({
          isFirstStream: false
        });
        clearTimeout(_timer.current);
        _timer.current = null;
      }, TIMER_INTERVAL);
    }
  };

  var handleCanPlay = function handleCanPlay() {
    videoRef.current.play();
    setStatus('playVideo');
  };

  var handleVideoPlay = function handleVideoPlay() {
    if (TIMER_INTERVAL && TIMER_INTERVAL > 0) {
      createVideoTimer();
    }
  };

  var handleAttachMedia = function handleAttachMedia() {
    console.log(Hls.Events.MEDIA_ATTACHED);

    _hls.current.loadSource(streamUrl);
  };

  var handleManifestParsed = function handleManifestParsed() {
    console.log(Hls.Events.MANIFEST_PARSED);
    videoRef.current.play();
    setStatus('playVideo');
  };

  var handleError = function handleError(_, data) {
    console.log(Hls.Events.ERROR);

    if (data.fatal) {
      setStatus('error');

      if (_hls.current) {
        _hls.current.stopLoad();

        _hls.current.destroy();

        _hls.current = null;
      }

      if (_timer.current) {
        clearTimeout(_timer.current);
        _timer.current = null;
      }

      handleVideoStatus({
        isFirstStream: true
      });
      setTriggerReload(false);
    }
  };

  var createVideoPlayer = function createVideoPlayer() {
    if (videoRef.current && !_hls.current) {
      if (Hls.isSupported() && /Safari/.test(navigator.userAgent)) {
        _hls.current = new Hls({
          manifestLoadingMaxRetry: 3
        });

        _hls.current.attachMedia(videoRef.current);

        _hls.current.on(Hls.Events.MEDIA_ATTACHED, handleAttachMedia);

        _hls.current.on(Hls.Events.MANIFEST_PARSED, handleManifestParsed);

        _hls.current.on(Hls.Events.ERROR, handleError);

        videoRef.current.addEventListener('play', handleVideoPlay);
      } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
        videoRef.current.src = streamUrl;
        videoRef.current.addEventListener('canplay', handleCanPlay);
        videoRef.current.addEventListener('play', handleVideoPlay);
      }
    }
  };

  var handleVisibilityChange = function handleVisibilityChange() {
    if (document.hidden) {
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.removeEventListener('play', handleVideoPlay);
        videoRef.current.removeEventListener('canplay', handleCanPlay);
      }

      if (_hls.current) {
        _hls.current.stopLoad();

        _hls.current.destroy();

        _hls.current = null;
      }

      if (_timer.current) {
        clearTimeout(_timer.current);
        _timer.current = null;
      }

      setPageResume(false);
    }

    if (document.visibilityState === 'visible') {
      setPageResume(true);
    }
  };

  useEffect(function () {
    if (pageResume) {
      var firstLoading = !triggerReload && videoStatus.isFirstStream;
      var reloading = triggerReload && !videoStatus.isFirstStream;

      if (firstLoading || reloading) {
        createVideoPlayer();
      }
    }
  }, [pageResume, triggerReload, streamUrl, videoStatus.isFirstStream, createVideoPlayer]);
  useEffect(function () {
    if (!_hls.current && videoRef.current) {
      createVideoPlayer();
    }
  }, [streamUrl, index]);
  useEffect(function () {
    if (triggerReload) {
      if (_hls.current) {
        _hls.current.destroy();

        _hls.current = null;
      }

      setStatus('loading');
      createVideoPlayer();
    }
  }, [streamUrl, index, triggerReload]);
  useLayoutEffect(function () {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return function () {
      document.removeEventListener('visibilitychange', handleVisibilityChange);

      if (videoRef.current) {
        videoRef.current.removeEventListener('play', handleVideoPlay);
        videoRef.current.removeEventListener('canplay', handleCanPlay);
      }

      if (_hls.current) {
        _hls.current.stopLoad();

        _hls.current.destroy();

        _hls.current = null;
      }

      if (_timer.current) {
        clearTimeout(_timer.current);
        _timer.current = null;
      }

      handleVideoStatus({
        isFirstStream: true
      });
      setTriggerReload(false);
    };
  }, [streamUrl, index]);
  return /*#__PURE__*/React.createElement("div", {
    className: "hls-video-block"
  }, /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    autoPlay: true,
    playsInline: true,
    muted: "muted",
    id: "its-video-".concat(streamUrl, "-").concat(index),
    controls: false
  }), status !== 'playVideo' && /*#__PURE__*/React.createElement("div", {
    className: "loading"
  }, status === 'loading' && /*#__PURE__*/React.createElement("i", {
    className: "fa fa-circle-notch fa-spin fa-3x fa-fw"
  }), status === 'error' && /*#__PURE__*/React.createElement("span", null, "\u7121\u6CD5\u64AD\u653E")));
};

HlsVideoPlayer.propTypes = {
  streamUrl: PropTypes.string.isRequired,
  videoStatus: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  handleVideoStatus: PropTypes.func.isRequired,
  triggerReload: PropTypes.bool.isRequired,
  setTriggerReload: PropTypes.func.isRequired
};

var MJPEGVideoPlayer = function MJPEGVideoPlayer(props) {
  var videoStatus = props.videoStatus,
      streamUrl = props.streamUrl,
      height = props.height,
      handleVideoStatus = props.handleVideoStatus,
      triggerReload = props.triggerReload,
      setTriggerReload = props.setTriggerReload;

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      pageResume = _useState6[0],
      setPageResume = _useState6[1];

  var imgRef = useRef();
  var observerRef = useRef();

  var removeObserver = function removeObserver() {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
  };

  var handleLoadStream = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(videoUrl, controller) {
      var _response$body, response, reader, _yield$reader$read, done;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch(videoUrl, {
                signal: controller.signal
              });

            case 3:
              response = _context.sent;
              reader = (_response$body = response.body) === null || _response$body === void 0 ? void 0 : _response$body.getReader();

              if (reader) {
                _context.next = 9;
                break;
              }

              handleVideoStatus({
                isFirstStream: false
              });
              setTriggerReload(false);
              return _context.abrupt("return");

            case 9:
              if (!true) {
                _context.next = 20;
                break;
              }

              _context.next = 12;
              return reader.read();

            case 12:
              _yield$reader$read = _context.sent;
              done = _yield$reader$read.done;

              if (!done) {
                _context.next = 18;
                break;
              }

              handleVideoStatus({
                isFirstStream: false
              });
              setTriggerReload(false);
              return _context.abrupt("break", 20);

            case 18:
              _context.next = 9;
              break;

            case 20:
              _context.next = 29;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0.name !== 'AbortError' && _context.t0.name !== 'TypeError' && _context.t0.message !== 'Load failed')) {
                _context.next = 28;
                break;
              }

              handleVideoStatus({
                isFirstStream: false
              });
              setTriggerReload(false);
              return _context.abrupt("return");

            case 28:
              if (imgRef.current && imgRef.current.src === videoUrl) {
                // eslint-disable-next-line no-undef
                observerRef.current = new PerformanceObserver(function (performance) {
                  var entries = performance.getEntriesByName(videoUrl);
                  var entry = entries.find(function (_entry) {
                    return _entry.name.includes(videoUrl);
                  });

                  if (entry && entry.duration > 0) {
                    removeObserver();
                    handleVideoStatus({
                      isFirstStream: false
                    });
                    setTriggerReload(false);
                  }
                });

                if (observerRef.current) {
                  observerRef.current.observe({
                    entryTypes: ['resource']
                  });
                }
              }

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 22]]);
    }));

    return function handleLoadStream(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleVisibilityChange = function handleVisibilityChange(controller) {
    return function () {
      if (document.hidden) {
        controller.abort();
        removeObserver();
        setPageResume(false);
      }

      if (document.visibilityState === 'visible') {
        setPageResume(true);
      }
    };
  };

  useEffect(function () {
    var controller = new window.AbortController();

    if (pageResume) {
      var firstLoading = !triggerReload && videoStatus.isFirstStream;
      var reloading = triggerReload && !videoStatus.isFirstStream;

      if (imgRef.current && (firstLoading || reloading)) {
        var url = "".concat(streamUrl, "?t=").concat(new Date().getTime());
        imgRef.current.src = url;
        handleLoadStream(url, controller);
      }
    }

    return function () {
      controller.abort();
      removeObserver();
    };
  }, [pageResume, triggerReload, streamUrl, videoStatus.isFirstStream, handleLoadStream, removeObserver]);
  useEffect(function () {
    var url = "".concat(streamUrl, "?t=").concat(new moment().valueOf());
    var controller = new window.AbortController();
    imgRef.current.src = url;
    handleLoadStream(url, controller);
    document.addEventListener('visibilitychange', handleVisibilityChange(controller));
    return function () {
      controller.abort();
      removeObserver();
      document.removeEventListener('visibilitychange', handleVisibilityChange(controller));
      handleVideoStatus({
        isFirstStream: true
      });
      setTriggerReload(false);
    };
  }, [streamUrl]);
  useEffect(function () {
    var controller = new window.AbortController();

    if (triggerReload) {
      var url = "".concat(streamUrl, "?t=").concat(new moment().valueOf());
      imgRef.current.src = url;
      handleLoadStream(url, controller);
    }

    return function () {
      if (triggerReload) {
        controller.abort();
      }

      removeObserver();
    };
  }, [streamUrl, triggerReload]);
  useLayoutEffect(function () {
    return function () {
      var img = imgRef.current;

      if (img) {
        img.src = '';
      }
    };
  }, [streamUrl]);
  return /*#__PURE__*/React.createElement("img", {
    ref: imgRef,
    style: {
      width: '100%',
      height: height,
      verticalAlign: 'middle'
    },
    alt: "MJPEG Stream"
  });
};

MJPEGVideoPlayer.propTypes = {
  streamUrl: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  videoStatus: PropTypes.object.isRequired,
  handleVideoStatus: PropTypes.func.isRequired,
  triggerReload: PropTypes.bool.isRequired,
  setTriggerReload: PropTypes.func.isRequired
};
var videoPlayerConfig = {
  HLS: HlsVideoPlayer,
  MJPEG: MJPEGVideoPlayer
};

var EVMSVideoPlayer = function EVMSVideoPlayer(props) {
  var streamUrlType = props.streamUrlType,
      streamUrl = props.streamUrl,
      height = props.height,
      index = props.index;

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      triggerReload = _useState8[0],
      setTriggerReload = _useState8[1];

  var _useState9 = useState({
    isFirstStream: true // 預設為true，表示第一次載入

  }),
      _useState10 = _slicedToArray(_useState9, 2),
      videoStatus = _useState10[0],
      setVideoStatus = _useState10[1];

  var VideoPlayer = videoPlayerConfig[streamUrlType];

  var handleVideoStatus = function handleVideoStatus(_ref2) {
    var isFirstStream = _ref2.isFirstStream;
    setVideoStatus(function (prev) {
      if (isFirstStream !== undefined) {
        prev.isFirstStream = isFirstStream;
      }

      return _objectSpread({}, prev);
    });
  };

  if (VideoPlayer) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VideoPlayer, {
      streamUrl: streamUrl,
      index: index,
      height: height,
      videoStatus: videoStatus,
      handleVideoStatus: handleVideoStatus,
      triggerReload: triggerReload,
      setTriggerReload: setTriggerReload
    }), !videoStatus.isFirstStream && !triggerReload && /*#__PURE__*/React.createElement(ReloadMask, {
      handleReload: function handleReload() {
        return setTriggerReload(true);
      }
    }));
  } else {
    return null;
  }
};

var ReloadMask = function ReloadMask(_ref3) {
  var handleReload = _ref3.handleReload;
  return /*#__PURE__*/React.createElement("div", {
    className: "camera-reload-mask"
  }, /*#__PURE__*/React.createElement("button", {
    className: "camera-reload-btn",
    onClick: handleReload
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-play-circle"
  })));
};

ReloadMask.propTypes = {
  handleReload: PropTypes.func.isRequired
};
var FreewayVideoPlayer = /*#__PURE__*/React.memo(function (props) {
  var originStreamUrl = props.streamUrl,
      height = props.height;

  var _useState11 = useState(),
      _useState12 = _slicedToArray(_useState11, 2),
      streamUrl = _useState12[0],
      setStreamUrl = _useState12[1];

  var _interval = useRef();

  useEffect(function () {
    _interval.current = setInterval(function () {
      var timeStamp = new moment().valueOf();
      setStreamUrl("".concat(originStreamUrl, "&t=").concat(timeStamp));
    }, 6000);
    return function () {
      clearInterval(_interval.current);
      _interval.current = null;
    };
  }, []);
  return /*#__PURE__*/React.createElement("img", {
    src: streamUrl || originStreamUrl,
    style: {
      width: '100%',
      height: height
    }
  });
});
var TBKCVideoPlayer = /*#__PURE__*/React.memo(function (props) {
  var streamUrl = props.streamUrl,
      height = props.height;
  var imgRef = useRef();
  useEffect(function () {
    if (imgRef.current) {
      imgRef.current.src = streamUrl;
    }
  }, []);
  useLayoutEffect(function () {
    return function () {
      var img = imgRef.current;

      if (img) {
        img.src = '';
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement("img", {
    ref: imgRef,
    style: {
      width: '100%',
      height: height
    }
  });
});